import React from 'react';
import { useTranslation } from 'react-i18next';
import { FareProduct } from '../../services/types/apitypes';
import CardPassItem from './CardPassItem';

type CardPassesPayTopProps = {
  product: FareProduct;
};

export default function CardPassesPayTop({ product }: CardPassesPayTopProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus pb-4 ion-text-center">{t('cardpasses.add')}</h1>

      <CardPassItem
        title={product.name}
        price={product.price}
        info={product.validityDescription}
      />
    </>
  );
}
